export {
    default,
    type IntegrationContentTemplateProps,
} from './IntegrationContentTemplate';
